<template>
  <section>
    <div style="width: 100%;margin-top: 80px;">
      <b-container class="bv-example-row">
        <b-row align-h="start">
          <b-col
            cols="1"
            offset-xl="2"
          >
            <img
              class="title-icon"
              src="@/assets/images/company-content-title-ico.png"
            >
          </b-col>
          <b-col
            cols="4"
            offset-xl="0"
          >
            <h3>APP功能介绍</h3>
            <h5>APP Function Introduction</h5>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div
      id="demo3"
      class="jcImgScroll"
    >
      <ul>
        <li>
          <a path="./assets/images/module-stop-topimg_1.png"></a>

        </li>
        <li>
          <a path="./assets/images/module-stop-topimg_2.png"></a>

        </li>
        <li>
          <a path="./assets/images/module-stop-topimg_3.png"></a>

        </li>
        <li>
          <a path="./assets/images/module-stop-topimg_4.png"></a>

        </li>
        <li>
          <a path="./assets/images/module-stop-topimg_5.png"></a>

        </li>

      </ul>
    </div>
  </section>
</template>
<script>
import { jcImgScroll } from "@/js/jQuery-jcImgScroll.js";
import { change } from "@/js/change.js";
import $ from "jquery";
export default {
  name: "app",

  data() {
    return {
      show: false,
    };
  },
  methods: {},
  // 必须写function
  mounted: function () {
    change("#demo3", 850, 650);
  },
};

// function change() {
//   //演示三 ID改变下试试
//   $("#demo3").jcImgScroll({
//     arrow: {
//       width: 100,
//       height: 400,
//       x: 100,
//       y: 0,
//     },
//     width: 850, //设置图片宽度
//     height: 650, //设置图片高度
//     imgtop: 30, //每张图片的上下偏移量
//     imgleft: -50, //每张图片的左边偏移量
//     imgwidth: 30, //每张图片的宽度偏移量
//     imgheight: 60, //每张图片的高度偏移量
//     count: 3,
//     offsetX: 80,
//     NumBtn: false,
//     title: false,
//     setZoom: 0.8,
//   });
// }
export { change };
</script>
<style lang="stylus" >
.title-icon {
  width: 1.3rem;
}

.jcImgScroll {
  position: relative;
  height: 700px;
  margin: 40px auto 0 auto;
}

.jcImgScroll li {
  border: 4px solid white;
  box-shadow: 1px 1px 9px 0px rgba(106, 106, 222, 0.26);
  position: relative;
}

.jcImgScroll li a {
  background: #fff;
  display: block;
  position: relative;
  z-index: 99;
}

.jcImgScroll li, .jcImgScroll em, .jcImgScroll dl {
  display: none;
}

.jcImgScroll em.sPrev {
  background-size: 50%;
}

.jcImgScroll em.sPrev:before {
  background: url('../../../assets/images/zuojiantou.png') no-repeat left center;
}

.jcImgScroll em.sNext {
  background-size: 50%;
}

.jcImgScroll em.sNext:before {
  background: url('../../../assets/images/youjiantou.png') no-repeat right center;
}

.jcImgScroll dl dd {
  // background: url('@/assets/images/NumBtn.png') no-repeat 0 bottom;
  text-indent: -9em;
}

.jcImgScroll dl dd:hover, .jcImgScroll dl dd.curr {
  background-position: 0 0;
}

.jcImgScroll li .img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 50%;
}

.jcImgScroll li.select:hover .img {
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/module/components/App.vue